import { Injectable } from '@angular/core';
import { LogService } from './log.service';
@Injectable({
  providedIn: 'root'
})
export class LocalizationService {

  private debug(msg : string) : void{
  	this.log.debug("LocalizationService: "+msg);
  }
  constructor(private log : LogService) {
  	this.debug("constructor called.");

  }


}
